<script setup lang="ts">
const props = defineProps<{
    modelValue: boolean;
    accentColor: string;
}>();

const emit = defineEmits<{
    "update:modelValue": [value: boolean];
}>();

const toggle = () => {
    emit("update:modelValue", !props.modelValue);
};
</script>

<template>
    <button
        type="button"
        @click="toggle"
        class="flex w-8 flex-none cursor-pointer rounded-full p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        :style="modelValue ? { backgroundColor: accentColor } : {}"
        :class="[modelValue ? '' : 'bg-gray-200']"
    >
        <span class="sr-only">
            <slot>Toggle</slot>
        </span>
        <span
            aria-hidden="true"
            class="size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out"
            :class="[modelValue ? 'translate-x-3.5' : 'translate-x-0']"
        />
    </button>
</template>

<style scoped>
button:focus-visible {
    outline-color: v-bind(accentColor);
}
</style>
